export enum FileType {
    XLSX = 'XLSX',
    CSV = 'CSV',
}
